import * as React from 'react';
import { FeedEntryType } from '@shapeable/types';

export const FeedEntryTypesContext = React.createContext<FeedEntryType[]>(null);
export const FeedEntryTypesProvider = FeedEntryTypesContext.Provider;